module.exports = __webpack_public_path__ + "img/storehouse_tech_Normal_ua.a634154a.webp";